import { Slide } from "@jelly/lesson";
import { task as task03 } from "../../../../../task/course-02/lesson-10/task-03";

const task: Slide = {
  titleHtml: `Which of the following parameters is considered</br>only in the sharpness calculation method by Aures?`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
